export const limitaString = (value, limitSize) => {
    if (!value || !limitSize)
        return value;
    if (value.length > limitSize)
        return value.substring(0, limitSize) + "..."
    return value
}

export default limitaString;